import { mutationTypes } from '@/core/constants'
import { FiltroUtils } from '@/core/utils'
import paginacaoListagem from '@/core/store/default/paginacaoListagem'

export default {
	[mutationTypes.ADESAO.RESET_FILTRO_LISTAGEM](state) {
		FiltroUtils.limparFiltroAvancado(state.filtro)
	},
	[mutationTypes.ADESAO.SET_PAGINACAO_LISTAGEM](state, paginacao) {
		state.paginacao = paginacao
	},
	[mutationTypes.ADESAO.RESET_PAGINACAO_LISTAGEM](state) {
		state.paginacao = paginacaoListagem(['seq'], 25, 'ASC')
	},
	[mutationTypes.ADESAO.RESETAR_PAGINA_LISTAGEM](state) {
		state.paginacao.page = 1
	},
	[mutationTypes.ADESAO.SET_ITENS_SELECIONADOS](state, itens) {
		state.itensSelecionados = itens
	},
	[mutationTypes.ADESAO.RESET_ITENS_SELECIONADOS](state) {
		state.itensSelecionados = []
	},
	[mutationTypes.ADESAO.SET_JUSTIFICATIVA](state, justificativa) {
		state.justificativa = justificativa
	},
	[mutationTypes.ADESAO.SET_INFORMACOES_ADESAO](state, informacoes) {
		state.informacoesAdesao = informacoes || {}
	},
	[mutationTypes.ADESAO.RESET_INFORMACOES_ADESAO](state) {
		state.informacoesAdesao = {}
	},
	[mutationTypes.ADESAO.SET_POSSUI_ITENS_ELABORACAO](state, value) {
		state.isPossuiItensEmElaboracao = !!value
	},
	[mutationTypes.ADESAO.SET_POSSUI_ITENS_RASCUNHO](state, value) {
		state.isPossuiItensEmRascunho = !!value
	},
	[mutationTypes.ADESAO.SET_POSSUI_ITENS](state, { elaboracao, rascunho }) {
		state.isPossuiItensEmElaboracao = !!elaboracao
		state.isPossuiItensEmRascunho = !!rascunho
	},
	[mutationTypes.ADESAO.SET_ATUALIZA_LISTAGEM](state) {
		state.atualizaListagem++
	},
	[mutationTypes.ADESAO.SET_REVISAO](state, revisao) {
		state.revisao = revisao
	},
}
